import React from "react";
import { HubContextMenu } from "../../components";
import { Typography } from "@mui/material";
import { usePutPartRevertData } from "../../hooks";

const MENU_ITEMS = [
  {
    id: "revert",
    label: "Revert",
    icon: "RotateCcw",
  },
];

const revert = (i) => i.id != "revert";
export const PartHistoryContextMenu = ({ item, index, id }) => {
  const { mutate: putPartRevertData, isLoading } = usePutPartRevertData();

  const onSelect = (selected) => {
    switch (selected?.id) {
      case "revert":
        const payload = { id, historyId: item.id };
        putPartRevertData(payload);
        break;
      default:
        break;
    }
  };

  const isFirst = index <= 0;
  const ITEMS = isFirst ? MENU_ITEMS?.filter(revert) : MENU_ITEMS;

  return (
    <HubContextMenu
      id={"partHistory"}
      loading={isLoading}
      menuItems={ITEMS}
      onSelect={onSelect}
      IconButtonProps={{
        sx: {
          paddingTop: "0px !important",
          paddingBottom: "0px !important",
        },
      }}
      EndElements={
        isFirst && (
          <Typography
            variant="caption"
            sx={{ textAlign: "center", width: "100%", display: "block" }}
          >
            Cannot Revert to Current Details
          </Typography>
        )
      }
    />
  );
};
